module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-01@m.7ce745b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-01@m.jpg
// module id = 9tKy
// module chunks = 0